import React, { useEffect, useState } from "react";
import {
  Avatar,
  Backdrop,
  LogoLoader,
  NewTable,
  Placements,
  SmartTooltip,
  StatusTags,
  TableAdv,
} from "../../../../components";
//
import { useSelector, useDispatch } from "react-redux";
import {
  clearClientData,
  getClientsStart,
} from "../../../../redux/slices/client/clientSlice";
import { Link } from "react-router-dom";
import {
  getClientId,
  formatWords,
  getValueByKey,
  dateFormator,
  mapTableRows,
} from "../../../../utils";
import { usePagination } from "../../../../hooks";

const options = [
  { label: "10 rows", value: 10 },
  { label: "20 rows", value: 20 },
  { label: "30 rows", value: 30 },
  { label: "40 rows", value: 40 },
  { label: "50 rows", value: 50 },
  { label: "100 rows", value: 100 },
];

const ClientsWithAcitvePlacements = () => {
  const [searchValue, setSearchValue] = useState("");
  const dispatch = useDispatch();
  const { loading, error, clients, totalCount } = useSelector(
    (state) => state.client
  );

  const isLoading = loading;

  const { page, limit, setPage, handleLimitChange } = usePagination(
    10,
    (newPage, newLimit) => {
      dispatch(
        getClientsStart({
          page: newPage,
          limit: newLimit,
          filters: {
            "placements.0": { type: "EXISTS", value: 1 },
            search: {
              type: "SEARCH",
              value: searchValue,
            },
          },
          sort: { uiid: -1 },
          ret: "uiid businessName generalInfo email phone placements recordStatus website jobCode website",
          ref: "PlacementWithEmp",
          incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobCode",
        })
      );
    }
  );

  const tableData = clients?.data || []; // Add null check with default empty array

  const columns = [
    {
      key: "businessName",
      label: "Business Name",
      width: "min-w-[150px]! max-w-[350px]!",
      render: (row) => (
        <SmartTooltip
          description={row.businessName}
          size="xs"
          color="black"
          noicon
          tooltipPosition="bottom"
          portal={true}
        >
          <div className="flex items-center gap-2 line-clamp-1!">
            {row.website && row.website !== "" ? (
              <a
                className="flex items-center gap-2 cursor-pointer"
                href={row.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Avatar alt={row.businessName} size="sm" outline />
                <span className="text-linkblue line-clamp-1!">{row.businessName}</span>
              </a>
            ) : (
              <>
                <Link to="/client/client-details" state={{ code: row.uiid }}>
                  <div className="flex items-center gap-2 cursor-pointer">
                    <Avatar alt={row.businessName} size="sm" outline />
                    <span className="text-linkblue line-clamp-1!">
                      {row.businessName}
                    </span>
                  </div>
                </Link>
              </>
            )}
          </div>
        </SmartTooltip>
      ),
    },
    {
      key: "",
      label: "Client ID",
      render: (row) => (
        <div className="flex items-center gap-1">
          <span className="text-linkblue">
            <Link to="/client/client-details" state={{ code: row.uiid }}>
              {getClientId(row.uiid)}
            </Link>
          </span>
        </div>
      ),
    },
    {
      key: "emailId",
      label: "Email ID",
      render: (row) => (
        <Link
          to="/client/client-details"
          state={{ code: row.uiid }}
          className="flex items-center gap-1 max-w-[300px]"
        >
          <p className="text-ellipsis text-linkblue">
            {row?.email?.join(", ")}
          </p>
        </Link>
      ),
    },
    {
      key: "phone",
      label: "Contact No",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link to="/client/client-details" state={{ code: row.uiid }}>
            <span className="">
              {/* <span className="text-linkblue"> */}
              {Array.isArray(row.phone) &&
                row.phone.map((phone, index) => (
                  <div key={index}>{phone.code + "-" + phone.number}</div>
                ))}
            </span>
          </Link>
        </div>
      ),
    },
    {
      key: "netTerms",
      label: "Net Terms",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link to="/client/client-details" state={{ code: row.uiid }}>
            <span className="">
              {/* <span className="text-linkblue"> */}
              {row.generalInfo?.placementDetails?.recurring?.netTerms ||
                row.generalInfo?.placementDetails?.permanent?.netTerms ||
                "-"}
            </span>
          </Link>
        </div>
      ),
    },
    {
      key: "status",
      label: "Status",
      //render: (row) => row.recordStatus,
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link to="/client/client-details" state={{ code: row.uiid }}>
            <StatusTags
              tag={formatWords(
                "",
                getValueByKey(row.recordStatus, "RecordStatus")
              )}
            />
          </Link>
        </div>
      ),
    },

    {
      key: "placements",
      label: "Active Placements",
      render: (row) => (
        <Placements
          // data={row?.placements
          //   ?.filter((placement) => {
          //     const endDate = new Date(placement?.jobInfo?.endDate);
          //     const today = new Date();
          //     return !placement?.jobInfo?.endDate || endDate >= today;
          //   })
          //   .map((row) => {
          //     return {
          //       jobCode: row?.jobInfo?.jobCode,
          //       employeeName:
          //         row?.employeeId?.firstName +
          //           " " +
          //           row?.employeeId?.lastName || "-",
          //       employmentType:
          //         row?.employeeId?.employmentType === 1
          //           ? "Regular"
          //           : row?.employeeId?.employmentType === 2
          //           ? "Consultant"
          //           : row?.employeeId?.employmentType === 3
          //           ? "Contract"
          //           : "-" || "-",
          //       startDate: row?.jobInfo?.startDate || "-",
          //       endDate: row?.jobInfo?.endDate || "-",
          //     };
          //   })}
          data={Array.from(
            new Map(
              row?.placements
                ?.filter((placement) => {
                  const endDate = new Date(placement?.jobInfo?.endDate);
                  const today = new Date();
                  return !placement?.jobInfo?.endDate || endDate >= today;
                })
                .map((placement) => [
                  placement.uiid,
                  {
                    jobCode: placement?.jobInfo?.jobCode,
                    employeeName:
                      placement?.employeeId?.firstName +
                        " " +
                        placement?.employeeId?.lastName || "-",
                    employmentType:
                      placement?.employeeId?.employmentType === 1
                        ? "Regular"
                        : placement?.employeeId?.employmentType === 2
                        ? "Consultant"
                        : placement?.employeeId?.employmentType === 3
                        ? "Contract"
                        : "-" || "-",
                    startDate: placement?.jobInfo?.startDate || "-",
                    endDate: placement?.jobInfo?.endDate || "-",
                  },
                ])
            ).values()
          )}
          columnData={[
            // "id",
            {
              key: "jobCode",
              label: "Job Code",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <span className="text-linkblue">{row.jobCode}</span>
                </div>
              ),
            },
            {
              key: "employeeName",
              label: "Employee Name",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <span className="text-linkblue">{row.employeeName}</span>
                </div>
              ),
            },
            {
              key: "employmentType",
              label: "Employment Type",
              render: (row) => (
                <div className="flex items-center gap-1">
                  <span className="text-linkblue">{row.employmentType}</span>
                </div>
              ),
            },
            {
              key: "startDate",
              label: "Start Date",
              render: (row) => dateFormator(row.startDate, "month-day-year"),
            },
            {
              key: "endDate",
              label: "End Date",
              render: (row) => dateFormator(row.endDate, "month-day-year"),
            },
          ]}
          modalTitle="Active Placements"
        />
      ),
      // row.placements.length,
    },
    {
      key: "currency",
      label: "Currency",
      render: (row) => (
        <div className="flex items-center gap-1">
          <Link to="/client/client-details" state={{ code: row.uiid }}>
            <span className="">
              {row.generalInfo?.currencyType == 1
                ? "USD"
                : row.generalInfo?.currencyType == 2
                ? "INR"
                : "-" || "-"}
            </span>
          </Link>
        </div>
      ),
    },
  ];
  const mappedRows = mapTableRows(tableData, columns);

  useEffect(() => {
    dispatch(
      getClientsStart({
        page: page,
        limit: limit,
        filters: {
          "placements.0": { type: "EXISTS", value: 1 },
          search: {
            type: "SEARCH",
            value: searchValue,
          },
        },
        sort: { uiid: -1 },
        ret: "uiid businessName generalInfo email phone placements recordStatus website jobCode",
        ref: "PlacementWithEmp",
        incl: "employeeId jobInfo.startDate jobInfo.endDate jobInfo.jobCode",
      })
    );
    return () => {
      dispatch(clearClientData());
    };
  }, [page, limit, searchValue]); // Empty array will cause it to run once when the component mounts

  const handleSearch = (keyname, value) => {
    setSearchValue(value);
  };
  return (
    <div className="flex flex-col overflow-hidden">
      <TableAdv
        tableId={`clients_clientswithactiveplacements`}
        rows={mappedRows}
        columns={columns}
        showSlNo
        //
        serverPagination={true}
        totalCount={totalCount?.data}
        page={page}
        limit={limit}
        onPaginationChange={setPage}
        onLimitChange={handleLimitChange}
        serverSerchValue={searchValue}
        serverOnSearch={handleSearch}
        toolbarRight={{
          search:true,
          filter:true,
          download:true
        }}
      />
      <Backdrop isOpen={isLoading}>
        <LogoLoader />
      </Backdrop>
    </div>
  );
};

export default ClientsWithAcitvePlacements;
